import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { DefaultForms, SlotsProvider } from '@grandvisionhq/www-next/pages/my-account'
import { Page } from '@grandvisionhq/www-next/pages/my-account/appointments'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/my-account/dist/index.css'

const MyAccountAppointments: NextPage = () => {
  const slots = {
    appointmentSummarySlot: DefaultForms.AppointmentSummary,
  }
  return (
    <SlotsProvider slots={slots}>
      <Page />
    </SlotsProvider>
  )
}

export default compose(withCms(), withLayout(), withCart({ readOnly: true }))(MyAccountAppointments)
